var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileDocs = function SvgFileDocs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    style: {
      color: "#87aaca"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 2a.667.667 0 0 0-.667.667v10.666c0 .368.299.667.667.667h8a.667.667 0 0 0 .667-.667v-8a.667.667 0 0 0-.196-.471L9.805 2.195A.667.667 0 0 0 9.333 2H4Zm.667 10.667V3.333h4.39l2.276 2.276v7.058H4.667ZM6 8a.667.667 0 0 0 0 1.333h4A.667.667 0 1 0 10 8H6Zm-.667-1.333C5.333 6.298 5.632 6 6 6h2.667a.667.667 0 0 1 0 1.333H6a.667.667 0 0 1-.667-.666ZM6 10a.667.667 0 0 0 0 1.333h4A.667.667 0 1 0 10 10H6Z",
    clipRule: "evenodd"
  })));
};
export default SvgFileDocs;